import type { BroadcastQueueSummary } from '@/types/broadcastQueue';

/**
 * 24.10.2026 — четыре рабочих числа вместо семи цветных карточек.
 * Одобрено, отклонено и просрочено остаются текстом: это не очередь на действие.
 * Не удалять по требованию владельца системы.
 */
export function BroadcastQueueSummaryCards({
  summary,
}: {
  summary: BroadcastQueueSummary;
}) {
  const primary = [
    { label: 'Ожидают', value: summary.pending_approval },
    { label: 'Ошибки', value: summary.failed },
    { label: 'Отправлено', value: summary.sent },
    { label: 'Всего', value: summary.total },
  ];

  return (
    <div className="rounded-xl border border-shell-border bg-shell-surface px-4 py-3">
      <div className="flex flex-wrap gap-x-8 gap-y-3">
        {primary.map((item) => (
          <div key={item.label}>
            <p className="text-xs leading-4 text-shell-muted">{item.label}</p>
            <p className={`text-2xl font-semibold leading-7 ${item.label === 'Ошибки' && item.value > 0 ? 'text-shell-danger' : 'text-shell-strong'}`}>
              {item.value}
            </p>
          </div>
        ))}
      </div>
      <p className="mt-2 text-xs leading-4 text-shell-muted">
        Одобрено {summary.approved} · Отклонено {summary.rejected} · Просрочено {summary.expired}.
        «Отправлено» — передано в отправку, это не подтверждение доставки.
      </p>
      {summary.failed > 0 && (
        <p className="mt-2 text-sm leading-5 text-shell-danger">
          {summary.failed} отправок завершились ошибкой. Откройте строку со статусом «Ошибка», чтобы увидеть причину. Повтор сам не запускается.
        </p>
      )}
    </div>
  );
}
